import { SiteContent, SiteMain, MainContentStart, BoundedContent, useBrowserClasses, getRootClassNames } from '@vp/swan'
import { Article } from './types/article.type'
import { ArticleView } from './components/article/Article'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { ContactUs } from '../src/components/contact-us/ContactUs'
import { HelpCenterUrls } from './types/helpCenterUrls.type'
import './App.scss'

interface Props {
  tenant: string
  locale: string
  article: Article
  config?: {
    hcServiceUrl: string
    useStaging?: boolean
  }
  helpCenterUrls: HelpCenterUrls | null
}

export const App = (props: Props) => {
  const { tenant, locale, article, helpCenterUrls, config } = props

  const lng = locale?.toLowerCase().replace('-', '_')
  const { t } = useTranslation(tenant)
  const bodyClassName = getRootClassNames()
  const htmlClassName = useBrowserClasses()
  const handleBackBtnClick = () => {
    if (typeof window !== 'undefined') {
      window.location.href = article.articleSectionUrl
    }
  }
  return (
    <>
      <Helmet bodyAttributes={{ class: bodyClassName }} htmlAttributes={{ class: htmlClassName }} defer>
        <title>
          {article.articleTitle ? `${article.articleTitle} - ` : ''}
          {t(`${tenant}:page.seo.title`, { lng })}
        </title>
      </Helmet>
      <SiteContent>
        <SiteMain>
          <MainContentStart>
            <BoundedContent className="bounded-content">
              <ArticleView
                article={article}
                locale={locale}
                tenant={tenant}
                handleBackBtnClick={handleBackBtnClick}
                helpCenterUrls={helpCenterUrls}
                useStaging={config?.useStaging}
              />
            </BoundedContent>
            <ContactUs locale={locale} tenant={tenant} articleId={article.articleId} />
          </MainContentStart>
        </SiteMain>
      </SiteContent>
    </>
  )
}
